<template>
    <div>
        <loading-indicator message="Submitting your order."></loading-indicator>
    </div>
</template>

<script>
import LoadingIndicator from '@/components/layout/LoadingIndicator'
import SampleOrder from "@/components/models/SampleOrder";
import FlatOrderDto from "@/components/models/FlatOrderDto";
export default {
    props: ['sampleobject'],
    components: {LoadingIndicator},
    methods: {
        postOrder() {
            var flatDtoTemp = new FlatOrderDto(this.sampleobject);
            var flatDto = this.setSignToCylinder(flatDtoTemp);
            axios.post('/order', flatDto)
                .then(response => {     
                    var orderResponse = response.data;          
                    if (!orderResponse.success) {
                        this.$router.replace('/error');
                    }
                    else{
                         this.$router.replace('/confirmation/' + orderResponse.vwOrderNumber )
                    }
                })
                .catch(error => {
                    this.$router.replace('/error')
                });
        },
        setSignToCylinder(flatDto) {
            let leCyl = flatDto.lecyl;
            let reCyl = flatDto.recyl;
            if (!leCyl)
                leCyl = '';
            if (!reCyl)
                reCyl = '';
            if (leCyl[0] == "0" && reCyl[0] == "0"){
                flatDto.lecyl = "+" + leCyl;
                flatDto.recyl = "+" + reCyl; 
            } else if ((leCyl[0] == "+" || leCyl[0] == "-") && reCyl[0] == "0") {
                flatDto.recyl = leCyl[0] + reCyl;
            } else if ((reCyl[0] == "+" || reCyl[0] == "-") && leCyl[0] == "0") {
                flatDto.lecyl = reCyl[0] + leCyl;
            }
            return flatDto;
        }
    },
    created() {
        if (this.sampleobject) {
            this.postOrder();
        }
        else {
            this.$router.replace('/error')
        }
    }
}
</script>